import { createContext, useContext, type ReactNode } from "react";
import type { DialerApi } from "./types";

const Ctx = createContext<DialerApi | null>(null);

export const DialerApiProvider = ({
  api,
  children,
}: {
  api: DialerApi;
  children: ReactNode;
}) => <Ctx.Provider value={api}>{children}</Ctx.Provider>;

// eslint-disable-next-line react-refresh/only-export-components
export function useDialerApi(): DialerApi {
  const api = useContext(Ctx);
  if (!api)
    throw new Error("useDialerApi must be used inside <DialerApiProvider>");
  return api;
}

/** GAVION skip-callback: the DialerApi when one is mounted (a page rendered without it simply hides its actions). */
// eslint-disable-next-line react-refresh/only-export-components
export function useOptionalDialerApi(): DialerApi | null {
  return useContext(Ctx);
}
